export const ApiAttachments = (axios, obuBaseUrl) => {
  axios.setBaseURL(obuBaseUrl)

  const create = async (formData) => {
    axios.setHeader('Content-Type', 'multipart/form-data')
    const result = await axios.$post('/api/settings/attachments', formData)
    return result
  }

  const find = async (id) => {
    const result = await axios.get(`/api/settings/attachments/${id}`)
    return result.data
  }

  const load = async () => {
    const result = await axios.get('/api/settings/attachments')
    return result.data
  }

  const save = async (id, payload) => {
    const result = await axios.post(`/api/settings/attachments/${id}`, payload)
    return result.data
  }

  return {
    attachmentsCreate: create,
    attachmentsFind: find,
    attachmentsLoad: load,
    attachmentsSave: save
  }
}
